import React, { useState, useEffect, useRef } from "react";
//naviagte import
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaCheck } from "react-icons/fa";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// CSS For Wallet
import "../css/Revolution.css";

// Import Font Awesome
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCreditCard,
    faBell,
    faCommentDots,
    faStar,
    faUsers,
    faCircleCheck,
    faQuestionCircle,
    faVideo,
    faUser,
    faSignOutAlt,
    faCog,

} from "@fortawesome/free-solid-svg-icons";


// Import Iconify for icons
import { Icon } from "@iconify/react";

function Revolution() {
    const transactions = [
        { id: 1, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
        { id: 2, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
        { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
    ];

    //localstorage token


    // for top tabs functionality
    const [activeTab, setActiveTab] = useState("forYou");
    //navigate page
    const navigate = useNavigate();
    // for prime public button click 

    // modal 
    const [modal, setModal] = useState(false);
    //msg tab acitivate
    // const [activeTab, setActiveTab] = useState("all");

    const toggle = () => setModal(!modal);
    // for sidebar buttons
    const [activeSidebar, setActiveSidebar] = useState("prime");
    //msg drwaer
    const [showMsgDrawer, setShowMsgDrawer] = useState(false);

    // for menu toggle functionality
    const [showSidebar, setShowSidebar] = useState(true);

    // profile settings
    const [showProfile, setShowProfile] = useState(false);
    const profileRef = useRef(null);

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setShowProfile(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);




    //dropdown revolution
    
    const [showRevolutionCard, setShowRevolutionCard] = useState(false);

    //naviagte profile page


    const goToProfile = () => {
        navigate("/profile");
    };
    //logout 

    const handleLogout = () => {
        const confirmLogout = window.confirm("Are you sure you want to logout?");//alert for confirmation

        if (confirmLogout) {
            //clear everything
            // localStorage.clear();

            //Redirect to login page
            navigate("/login");
        }
    };

    return (
        <div className="page-wrapper">
            {/* <div className="page-container"> */}

            {/* ================= GLOBAL TOP-RIGHT ICONS ================= */}
            <div className="page-top-container">
                <nav className="navbar top-header px-3 px-md-5">

                    {/* -----------company Logo------------ */}
                    <div
                        className="company-logo"
                        onClick={() => setShowSidebar(prev => !prev)}
                    >
                        <img src="/images/logo1.jpg" alt="logo1" />
                    </div>

                    {/*  */}

                    <div className="search-box">
                        <i className="prime-search-icon"><Icon icon="ic:sharp-search" /></i>
                        <input
                            type="text"
                            placeholder="Search Politics , Parties and Leadership"
                        />
                    </div>


                    <div className="global-icons d-flex gap-0 gap-md-2 align-items-center">
                        <span
                            className="position-relative border-0 cursor-pointer"
                            onClick={() => navigate("/wallet")}
                        >
                            <FontAwesomeIcon
                                icon={faCreditCard}
                                className="icon-box"
                            />

                            <span className="global-creditCard-data position-absolute translate-middle badge rounded-pill bg-danger">
                                <Icon icon="ic:sharp-currency-rupee" /> 50
                            </span>
                        </span>

                        {/*----------------------- Notification---------------------- */}

                        <span
                            className="position-relative border-0 bell-icon"
                            style={{ cursor: "pointer" }}
                            onClick={toggle}
                        >
                            <FontAwesomeIcon icon={faBell} className="icon-box" />

                        </span>

                        {/* Reactstrap Modal */}
                        <Modal isOpen={modal} toggle={toggle} centered>
                            <ModalHeader toggle={toggle}>
                                Notifications
                            </ModalHeader>

                            <ModalBody>
                                <p>Your post received new likes.</p>
                                <small className="text-muted">2 days ago</small>

                                <hr />

                                <p>
                                    Learn how Meta will use your info in new ways to personalize your
                                    experience.
                                </p>
                                <small className="text-muted">9 weeks ago</small>
                            </ModalBody>

                            <ModalFooter>
                                <Button color="secondary" onClick={toggle}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>

                        {/* ----------------------------Profile ---------------------------------- */}

                        <span
                            className="position-relative border-0 msg-icon"
                            onClick={() => setShowMsgDrawer(true)}
                        >
                            <FontAwesomeIcon icon={faCommentDots} className="icon-box" />
                        </span>


                        {/* PROFILE ICON */}
                        <div className="position-relative" ref={profileRef}>
                            <FontAwesomeIcon
                                icon={faUser}
                                className="icon-box profile-icon"
                                onClick={() => setShowProfile(!showProfile)}
                            />

                            {/* PROFILE POPUP */}
                            {showProfile && (
                                <div className="profile-popup">

                                    {/* Profile Card */}
                                    <div className="profile-card">
                                        <div className="profile-header">
                                            <div className="avatar">
                                                <FontAwesomeIcon icon={faUser} />
                                            </div>
                                            <span className="username">Helena king</span>
                                        </div>

                                        <div className="divider"></div>

                                        <button className="see-profile-btn">
                                            <FontAwesomeIcon icon={faUsers} /> See all profiles
                                        </button>
                                    </div>

                                    {/* Menu Items */}
                                    <div className="profile-popup-item">
                                        <FontAwesomeIcon icon={faCog} />
                                        <span>Settings & privacy</span>
                                        {/* <span className="arrow">›</span> */}
                                    </div>

                                    <div className="profile-popup-item">
                                        <FontAwesomeIcon icon={faQuestionCircle} />
                                        <span>Help & support</span>
                                        {/* <span className="arrow">›</span> */}
                                    </div>

                                    <div
                                        className="profile-popup-item logout"
                                        onClick={handleLogout}
                                    >
                                        <FontAwesomeIcon icon={faSignOutAlt} />
                                        <span>Logout</span>
                                    </div>

                                    {/* Footer */}
                                    <div className="popup-footer">
                                        Privacy · Terms · Advertising · Ad Choices · Cookies · More
                                    </div>
                                </div>
                            )}
                        </div>


                    </div>
                </nav>
            </div>

            {/* ----------------------------------Msg Drawer-------------------------------------- */}
            {showMsgDrawer && (
                <>
                    <div
                        className="msg-overlay"
                        onClick={() => setShowMsgDrawer(false)}
                    ></div>

                    <div className="msg-drawer">
                        <div className="msg-header">
                            <h3>Chats</h3>
                            <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                        </div>

                        <div className="msg-search">
                            <input placeholder="Search Messenger" />
                        </div>

                        <div className="msg-tabs">
                            <span
                                className={activeTab === "all" ? "active" : ""}
                                onClick={() => setActiveTab("all")}
                            >
                                All
                            </span>

                            <span
                                className={activeTab === "unread" ? "active" : ""}
                                onClick={() => setActiveTab("unread")}
                            >
                                Unread
                            </span>

                            <span
                                className={activeTab === "groups" ? "active" : ""}
                                onClick={() => setActiveTab("groups")}
                            >
                                Groups
                            </span>

                            <span
                                className={activeTab === "communities" ? "active" : ""}
                                onClick={() => setActiveTab("communities")}
                            >
                                Communities
                            </span>
                        </div>

                        <div className="msg-empty">
                            <h4>No chats</h4>
                            <p>When you have chats, you’ll see them here..</p>
                        </div>

                        <div
                            className="msg-footer"
                            onClick={() => {
                                setShowMsgDrawer(false);
                                navigate("/message");
                            }}
                        >
                            See all in Messenger
                        </div>
                    </div>
                </>
            )}

            {/* ================= PRIME LAYOUT CONTAINER ================= */}
            <div className="prime-layout">
                <div className="row prime-row">

                    {/* ================= LEFT SIDEBAR ================= */}
                    <div
                        className={`sidebar-container col-lg-3 col-md-3 d-md-block ${showSidebar ? "sidebar-hide" : "sidebar-show"} `}
                    >
                        <aside className="sidebar">
                            <ul className="left-menu">

                                <li
                                    className={activeSidebar === "prime" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("prime");
                                        navigate("/prime");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faStar} /> Prime
                                </li>

                                <li
                                    className={activeSidebar === "public" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("public");
                                        navigate("/public");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUsers} /> Public
                                </li>

                               
                                <li
                                    className={`menu-item ${activeSidebar === "revolution" ? "active" : ""}`}
                                    onClick={() => {
                                        setActiveSidebar("revolution");
                                        setShowRevolutionCard(prev => !prev);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faVideo} /> Revolution
                                </li>



                                {showRevolutionCard && (
                                    <div className="revolution-card">
                                        <div onClick={() => navigate("/revolution/create")}>
                                            Create Revolution
                                        </div>

                                        <div onClick={() => navigate("/revolution/all")}>
                                            All Revolution
                                        </div>

                                        <div onClick={() => navigate("/revolution/my")}>
                                            My Revolution
                                        </div>
                                    </div>
                                )}
                                <li
                                    className={activeSidebar === "wallet" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("wallet");
                                        navigate("/wallet");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCreditCard} /> Wallet
                                </li>

                                <li
                                    className={activeSidebar === "profile" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("profile");
                                        navigate("/verified");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCircleCheck} /> Verified
                                </li>

                                <li
                                    className={activeSidebar === "settings" ? "menu-item active" : "menu-item"}
                                    onClick={() => {
                                        setActiveSidebar("settings");
                                        navigate("/profile");
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCog} /> Settings
                                </li>

                            </ul>

                        </aside>
                    </div>
                    {/*  */}
                    {/* ----------------------------------Msg Drawer-------------------------------------- */}
                    {showMsgDrawer && (
                        <>
                            <div
                                className="msg-overlay"
                                onClick={() => setShowMsgDrawer(false)}
                            ></div>

                            <div className="msg-drawer">
                                <div className="msg-header">
                                    <h3>Chats</h3>
                                    <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                                </div>

                                <div className="msg-search">
                                    <input placeholder="Search Messenger" />
                                </div>
                                <div className="msg-tabs">
                                    <span
                                        className={activeTab === "all" ? "active" : ""}
                                        onClick={() => setActiveTab("all")}
                                    >
                                        All
                                    </span>

                                    <span
                                        className={activeTab === "unread" ? "active" : ""}
                                        onClick={() => setActiveTab("unread")}
                                    >
                                        Unread
                                    </span>

                                    <span
                                        className={activeTab === "groups" ? "active" : ""}
                                        onClick={() => setActiveTab("groups")}
                                    >
                                        Groups
                                    </span>

                                    <span
                                        className={activeTab === "communities" ? "active" : ""}
                                        onClick={() => setActiveTab("communities")}
                                    >
                                        Communities
                                    </span>
                                </div>

                                <div className="msg-empty">
                                    <h4>No chats</h4>
                                    <p>When you have chats, you’ll see them here..</p>
                                </div>

                                <div
                                    className="msg-footer"
                                    onClick={() => {
                                        setShowMsgDrawer(false);
                                        navigate("/message");
                                    }}
                                >
                                    See all in Messenger
                                </div>
                            </div>
                        </>
                    )}
                    {/* ================= CENTER AREA ================= */}
                    <div className="col-md-9 col-12">




                    </div>
                </div>

                {/* ================= RIGHT SIDEBAR ================= */}

            </div>
        </div>





    );
}
export default Revolution;